export enum EInterventionStatus {
    New = 1,
    Validated = 2,
    Done = 3,
    Canceled = 4
}